import { render, staticRenderFns } from "./MultiChildrenVerticalMenu.vue?vue&type=template&id=ccac4218&scoped=true"
import script from "./MultiChildrenVerticalMenu.vue?vue&type=script&lang=js"
export * from "./MultiChildrenVerticalMenu.vue?vue&type=script&lang=js"
import style0 from "./MultiChildrenVerticalMenu.vue?vue&type=style&index=0&id=ccac4218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccac4218",
  null
  
)

export default component.exports